<template>
  <v-container class="pb-4 mt-6 mx-0 px-10" fluid>
    <v-row v-if="title" class="mt-0 mb-6">
      <v-col
        lg="12"
        md="12"
        class="d-flex align-center justify-space-between px-3"
      >
        <div class="d-flex align-center">
          <slot name="prepend"></slot>

          <div>
            <div class="d-flex align-center">
              <p
                v-snip="1"
                class="pa-0 ma-0 mr-3 headline blue-grey--text text--darken-3"
                data-testid="viewContainer-title"
              >
                {{ title }}
              </p>

              <slot name="title-append"></slot>
            </div>

            <p
              v-if="subtitle"
              data-testid="viewContainer-subtitle"
              v-snip="1"
              class="pa-0 ma-0 mr-3 subtitle-2 blue-grey--text text--darken-1"
            >
              {{ subtitle }}
            </p>
          </div>

          <slot name="header-right"></slot>
        </div>
        <slot name="append"></slot>
      </v-col>
    </v-row>
    <v-row fill-height v-if="breadcrumb" class="my-0">
      <v-col cols="12" class="pb-4">
        <BreadCrumb :links="breadcrumb" />
      </v-col>
    </v-row>

    <v-row fill-height>
      <v-col cols="12">
        <slot></slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BreadCrumb from '@/components/UI/BreadCrumb.vue'

export default {
  name: 'ViewContainer',

  components: {
    BreadCrumb,
  },

  props: {
    breadcrumb: {
      type: Array,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    subtitle: {
      type: String,
      required: false,
    },
  },
}
</script>
